export const ADD_TO_LIKE = "ADD_TO_LIKE";

export const addToLIKE = (item) => ({
    type: "ADD_TO_LIKE",
    payload: item,
});
